export const environment = {
  // appUrl: 'https://api-ics.herokuapp.com/', // what's this?
  production: false,
  appUrl: 'https://ics-shop-dev.azurewebsites.net/',
  apiIcsShop: 'https://ics-shop-dev.azurewebsites.net/api/',
  apiCmsExchequer: 'https://cms.ics-skills.net/api/exchequer/',
  apiCmsIcsShop:'https://cms.ics-skills.net/api/icsshop/',
  shopUrl: 'https://ics.shop.dev.skillsbox.com'
  



  // // local
  // appUrl: 'http://localhost:5000/',
  // apiIcsShop: 'http://localhost:5000/api/',
  // apiCmsExchequer: 'https://cms.ics-skills.net/api/exchequer/',
  // apiCmsIcsShop:'https://cms.ics-skills.net/api/icsshop/',

};
